import {Service} from '@s-ui/domain'

export class GetEventTrackingDataService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.getResetTrackingDataService
   * @param {Service} deps.getIdentifyTrackingDataService
   * @param {Mapper} deps.fromEventTrackingDataToEventTrackingDataValueObjectMapper
   */
  constructor({
    getResetTrackingDataService,
    getIdentifyTrackingDataService,
    fromEventTrackingDataToEventTrackingDataValueObjectMapper
  }) {
    super()

    this._getResetTrackingDataService = getResetTrackingDataService
    this._getIdentifyTrackingDataService = getIdentifyTrackingDataService
    this._fromEventTrackingDataToEventTrackingDataValueObjectMapper =
      fromEventTrackingDataToEventTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} params
   * @param {String} params.event
   * @param {String} params.origin
   * @param {String} params.context
   * @param {Object} params.ad
   * @return {Promise<Object, Error>} This is a Promise return value.
   */
  async execute(params) {
    const {event} = params

    if (!event) return

    const reset = await this._getResetTrackingDataService.execute()
    const identify = await this._getIdentifyTrackingDataService.execute({event})

    return this._fromEventTrackingDataToEventTrackingDataValueObjectMapper
      .setParams({reset, identify})
      .map(params)
      .toJSON()
  }
}
